// In your saga file (e.g., src/store/auth/saga.js or src/store/sagas.js)
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Import your action types and action creators
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { loginSuccess, logoutUserSuccess, apiError } from "./actions"
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper"
import { openWelcome } from "store/agenda/action"


const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        async (url = process.env.REACT_APP_ADMIN + "/login", data = user) => {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
          })
          return response.json()
        }
      )
      
      console.log("[Saga] Login response:", response);
      
      // Check if response is successful and has data
      if (response.success && response.data && response.data.Email) {
        console.log("[Saga] Login successful, setting localStorage items")
        
        // IMPORTANT: Set both authUser AND datasaved
        localStorage.setItem("authUser", JSON.stringify(response.data));
        localStorage.setItem("datasaved", "true"); // NEW: Set datasaved flag
        
        yield put(loginSuccess(response.data));
        yield put(openWelcome());
        history.push("/dashboard");
      } else {
        // Handle error - don't navigate to dashboard
        console.error("[Saga] Login failed:", response.mssg)
        localStorage.removeItem("authUser");
        localStorage.removeItem("datasaved"); // NEW: Remove datasaved on error
        localStorage.removeItem("activityArr");
        yield put(apiError(response.mssg || "Login failed. Please try again."));
      }
      
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      localStorage.setItem("datasaved", "true") // NEW: Set datasaved flag
      yield put(loginSuccess(response))
      history.push("/dashboard")
      
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      localStorage.setItem("datasaved", "true") // NEW: Set datasaved flag
      yield put(loginSuccess(response))
      history.push("/dashboard")
    }
    
  } catch (error) {
    console.error("[Saga] Login error:", error)
    localStorage.removeItem("datasaved"); // NEW: Remove datasaved on error
    yield put(apiError(error))
  }
}

// Also update logout saga to clear datasaved
function* logoutUser({ payload: { history } }) {
  try {
    console.log("[Saga] Logout initiated, clearing localStorage")
    
    localStorage.removeItem("authUser");
    localStorage.removeItem("notificationToken")
    localStorage.removeItem("datasaved"); // NEW: Clear datasaved on logout
    localStorage.removeItem("activityArr");
    
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      // Your firebase logout logic
          //   const response = yield call(fireBaseBackend.logout)
          //  
      // const response = yield call(firebaseLogout)
    }
    
    yield put(logoutUserSuccess());
    CometChatWidget.logout().then(response => {
      // User successfully logged out.
    // Perform any clean up if required.
    console.log("chat logout success!");
  });
    history.push("/login");
  } catch (error) {
    console.error("[Saga] Logout error:", error)
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      )
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
    // window.location.href="/page/lobby"
  } catch (error) {
    yield put(apiError(error))
  }
}

// Make sure to export your saga watchers
export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser)
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser)
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
